module.exports = __webpack_public_path__ + "04_mid_brown.66e98509.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_mid_brown.png
// module id = x5uG
// module chunks = 0